import React, { useState } from "react";
import Input from "../../components/FormComponents/Input";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";

const Lookup = ({ element }) => {
  return (
    <>
      <div className="builder_dropdown_outer">
        <select className="builder_input" defaultValue="Select an Option">
          <option disabled value="">
            Select an Option
          </option>
          {element?.data?.values?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

const LookupSm = ({ element }) => {
  return (
    <>
      <div className="builder_dropdown_outer">
        <select className="builder_input" defaultValue="Select an Option">
          <option disabled value="">
            Select an Option
          </option>
          {element?.data?.values?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};
const AppUser = ({ fields }) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <MaterialIcon name="person" />
      <div className="key_tag">
        {fields?.map((field, index) => (
          <span key={index}>
            <span>
              ({field.activity_label},{field.display}){" "}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};

const SliderBox = ({ element }) => {
  const [sliderValue, setSliderValue] = useState(0);

  const handleChange = (event) => {
    setSliderValue(event.target.value);
  };
  return (
    <div className="builder_form">
      <div className="builder_label">{<span className="key_tag">[{sliderValue}]</span>}</div>
      <Input
        type="range"
        min={element.slider_min}
        max={element.slider_max}
        step={element.slider_step}
        value={sliderValue}
        onChange={handleChange}
      />
    </div>
  );
};

export { Lookup, AppUser, LookupSm, SliderBox };
